import type { JourneySubmissionFailedAction } from '../types/actions'
import { SUBMISSION_STATUS } from '../types/enums'

import { actionFactory } from './factory'

export const journeySubmissionFailed =
  actionFactory<JourneySubmissionFailedAction>((state) => {
    state.submissionState = {
      status: SUBMISSION_STATUS.FAILED
    }
  }, 'journeySubmissionFailed')
